export enum ImportedOrdersTracingConstants {
  capability = 'orders',
  importedOrdersPageLoad = 'Imported Orders Page Load',
}
